export const DEFAULT_ERROR_MESSAGE = {
  title: '잠시 오류가 발생했어요',
  message: '접속에 문제가 생겼어요.\n잠시 후 다시 시도해 주세요.',
};
